export default "__VITE_ASSET__Cdxu83Cl__"